import { supabase } from "@/integrations/supabase/client";

const STORAGE_BUCKETS = ["reference-photos", "cleaning-photos"] as const;

/** Extract object path from a Supabase storage public/authenticated URL. */
export function storageObjectPathFromUrl(url: string, bucket: string): string | null {
  if (!url?.trim()) return null;
  try {
    const pathname = new URL(url).pathname;
    const prefixes = [
      `/object/public/${bucket}/`,
      `/object/authenticated/${bucket}/`,
      `/object/sign/${bucket}/`,
    ];
    for (const prefix of prefixes) {
      const idx = pathname.indexOf(prefix);
      if (idx !== -1) {
        return decodeURIComponent(pathname.slice(idx + prefix.length));
      }
    }
  } catch {
    return null;
  }
  return null;
}

/** Prefer a signed URL so cleaners can view private bucket objects while authenticated. */
export async function resolveStorageDisplayUrl(url: string): Promise<string> {
  if (!url?.trim()) return url;
  for (const bucket of STORAGE_BUCKETS) {
    const path = storageObjectPathFromUrl(url, bucket);
    if (!path) continue;
    const { data, error } = await supabase.storage.from(bucket).createSignedUrl(path, 60 * 60);
    if (!error && data?.signedUrl) return data.signedUrl;
  }
  return url;
}
